import { MdDragIndicator } from 'react-icons/md';
import { MFlex, MIcon, MText } from '../../../components/Monetize';

interface ApproverRowDraggablePreviewProps {
  label?: string;
}

export const ApproverRowDraggablePreview = ({
  label,
}: ApproverRowDraggablePreviewProps) => {
  return (
    <MFlex
      bg="white"
      border="1px solid"
      borderColor="tGray.back"
      borderRadius={4}
      px={3}
      py={2}
      alignItems="center"
      gap={2}
      shadow="md"
      minW="240px"
      maxW="480px"
    >
      <MIcon as={MdDragIndicator} boxSize={4} color="tPurple.dark" />
      <MText fontSize="sm" lineClamp={1}>
        {label || 'Approver'}
      </MText>
    </MFlex>
  );
};
